import type {SubscriptionTier} from '../SubscriptionTier.js'

export const noSubscriptionTier = {
  tier: 'none',
  canUpgrade: true,
  features: {
    maxActiveProjects: 0,
    maxActiveConnections: 0,
    manualTimeEntryCreation: true,
    recommendationRefresh: {
      automaticInterval: 'never',
      allowManual: false,
    },
  },
} satisfies SubscriptionTier
